import { EnquiryForm } from "./EnquiryForm";
import { FORMS } from "./formConfig";

export default function NetworkForm() {
  return <EnquiryForm config={FORMS.network} />;
}
